import { render } from "./PurchaseOrderView.vue?vue&type=template&id=07c954f3&scoped=true"
import script from "./PurchaseOrderView.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderView.vue?vue&type=script&lang=js"

import "./PurchaseOrderView.vue?vue&type=style&index=0&id=07c954f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c954f3"]])

export default __exports__